module.exports = __webpack_public_path__ + "img/book.031b097f.svg";